import { useState, useEffect, useContext } from "react";
import { CommonTable, SearchableDropdown, Loader, CommonFilter, } from "../../Components/Common";
import { FiDownload, FiUpload, FiTrash2, FiFilter,} from "react-icons/fi";
import { UserContext } from "../../Context";
import { EMP_DOC_LABELS, EMP_DOC_COLUMNS, } from "./constants";
import { useESS } from "./Hooks/useESS.js";
import { RESET_PAGINATION, ROLES } from "../../Constants/Strings";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { USER_PAGE } from "../../routes.js";
import toast from "react-hot-toast";
import { downloadFile } from "../Folders/Components/downloadUtils.js";

const EmpDocs = () => {

    const {
        filters,
        setFilters,
        fetchAllESS,
        uploadEmpDocument,
        getUsers,
        deleteESS,
        loadMoreESS,
        pagination,
        setPagination,
        loading,
    } = useESS();

    const [ess, setESS] = useState([]);
    const { user } = useContext(UserContext);
    const [formData, setFormData] = useState({
        user: "",
        file_name: "",
        description: "",
        file: null,
    });

    const [isOpen, setIsOpen] = useState(false);
    const [tempFilters, setTempFilters] = useState(filters);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedUser, setSelectedUser] = useState();
    const navigate = useNavigate();

    const loadESS = async () => {
        const data = await fetchAllESS({ offset: 0, limit: pagination.limit }, true);
        setESS(data);
    };
    const [ uploadLoading, setUploadLoading] = useState(false);
    const [ isUploadDisable, setIsUploadDisable] = useState(false);
    const handleDownloadFile = async(file) => {
      try {
        const data = await downloadFile(file);
        if(data){
          toast.success("Downloaded successfully");
        }
      } catch (error) {
        toast.error("Failed to download file");
      }

    };

    const deleteDoc = async (id) => {
        const success = await deleteESS(id);
        if (success) loadESS();
    }

        const handleApplyFilters = () => {
            setFilters({
              ...tempFilters,
              user: tempFilters.user?.id || ""
            });
            setPagination(RESET_PAGINATION);
            setESS([]);
            setShowFilter(false);
            setSelectedUser(filters.user || null);
        };
    
        const handleClearFilters = () => {
            const cleared = { status: "", user: "", category: "" };
            setTempFilters(cleared);
            setFilters(cleared);
            setPagination(RESET_PAGINATION);
            setESS([]);
            setSelectedUser(null);
        };
    
    
        const handleCancelFilters = () => {
            setTempFilters(filters);
            setShowFilter(false);
            setSelectedUser(filters.user || null);
        };

    const renderField = (key, row) => {
        if (key === "file") {
            const fileName = row.file ? row.file.split("/").pop() : "";
            return fileName;
        }
        if (key === "action") {
            return (
                <div className = "flex justify-start gap-0" >
                    <button
                        className="p-2 text-gray-700"
                        onClick={() => handleDownloadFile(row.file)}
                    >
                        <FiDownload className="text-md" />
                    </button>
                    {/* DELETE — only for HR */}
                    {[ROLES.HR, ROLES.DIRECTOR_MANAGEMENT].includes(user?.role) && (
                        <button
                            className="text-red-700 p-2"
                            onClick={ () => deleteDoc(row.id)}
                        >
                            <FiTrash2 className="text-lg" />
                        </button>
                    )}
                </div>
            );
        }

        return row[key] || "-";
    };

    const renderMobileCards = () => {
        return (
            <div className="md:hidden space-y-4 mt-4">
                {ess.length === 0 ? (
                    <p className="text-center text-gray-600">No documents found.</p>
                ) : (
                    ess.map((row) => {
                        return (
                            <div
                                key={row.id}
                                className="border rounded-lg shadow-sm p-4 bg-white"
                            >
                                <div className="mb-1">
                                    <p className="font-semibold text-primary flex justify-between">
                                        <span>{row.username}</span>
                                        <div className="flex items-center justify-end gap-2">
                                            <button
                                                className="flex items-center gap-2 text-primary"
                                                onClick={() => downloadFile(row.file)}
                                            >
                                                <FiDownload className="text-2xl" />
                                            </button>
                                            {[ROLES.HR, ROLES.DIRECTOR_MANAGEMENT].includes(user?.role) && (
                                                <button
                                                    className="flex items-center gap-2 text-red-600"
                                                    onClick={() => deleteDoc(row.id)}
                                                >
                                                    <FiTrash2 className="text-2xl" />
                                                </button>
                                            )}
                                        </div>
                                    </p>
                                    <p className="font-semibold text-primary flex justify-between">
                                        <span className="text-gray-900 font-normal"> {row.file_name}</span>
                                    </p>
                                    
                                    <p className="font-semibold text-primary flex justify-between">
                                        <span className="text-gray-900 font-normal"> {row.description || "No description"}</span>
                                    </p>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        )
    };

    const renderForm = () => {
        return (
          <>
            {isOpen && (
              <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
                  <h2 className="text-lg font-semibold mb-4">
                    Upload Document
                  </h2>

                  {/* User Dropdown */}
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Employee Name <span className="text-red-500">*</span>
                  </label>

                  <SearchableDropdown
                    fetchFunction={({ search }) =>
                      getUsers({ mode: "all", search })
                    }
                    onSelect={(user) => {
                      setSelectedUser(user);
                      setFormData((prev) => ({ ...prev, user: user?.id }));
                    }}
                    value={formData.user}
                    valueKey="id"
                    labelKey="first_name"
                    placeholder="Select Employee"
                  />

                  {/* File Name */}
                  <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">
                    File Name <span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    value={formData.file_name}
                    onChange={(e) =>
                      setFormData({ ...formData, file_name: e.target.value })
                    }
                    className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                    placeholder="Enter File Name"
                  />

                  {/* Description */}
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>

                  <input
                    type="text"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                    placeholder="Enter Description"
                  />

                  {/* File Upload */}
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Select File <span className="text-red-500">*</span>
                  </label>

                  <input
                    type="file"
                    onChange={(e) =>
                      setFormData({ ...formData, file: e.target.files[0] })
                    }
                    className="w-full border rounded-md px-3 py-2 mb-3"
                  />

                  {/* Buttons */}
                  <div className="flex justify-end gap-3 mt-4">
                    <button
                      className="px-3 py-2 bg-gray-300 rounded"
                      onClick={() => setIsOpen(false)}
                    >
                      Cancel
                    </button>

                    <button
                      disabled={
                        !formData.user || !formData.file_name || !formData.file
                      }
                      className="px-4 py-2 bg-primary text-white rounded disabled:cursor-not-allowed disabled:opacity-70"
                      onClick={async () => {
                        if (
                          !formData.user ||
                          !formData.file_name ||
                          !formData.file
                        ) {
                          setIsUploadDisable(true);
                          return;
                        }

                        try {
                          setUploadLoading(true);

                          const fd = new FormData();
                          fd.append("user", formData.user);
                          fd.append("file_name", formData.file_name);
                          fd.append("description", formData.description);
                          fd.append("file", formData.file);

                          await uploadEmpDocument(fd);

                          setIsOpen(false);
                          setFormData({
                            user: "",
                            file_name: "",
                            description: "",
                            file: null,
                          });

                          loadESS();
                        } catch (err) {
                          toast.error("Failed to upload.")
                        } finally {
                          setUploadLoading(false);
                        }
                      }}
                    >
                      {uploadLoading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        );
    };

    useEffect(() => {
        loadESS();
    }, [filters]);
    
    return (
      <div className="px-4 py-4">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold mb-4 text-primary">
            Employee Documents
          </h2>
          <div className="flex gap-2 items-center">
           {["HR","DIRECTOR_MANAGEMENT"].includes(user?.role?.toUpperCase()) && (
              <button
                className="px-4 py-2 rounded bg-primary hover:bg-green-600 text-white font-bold shadow-lg flex items-center gap-1"
                onClick={() => {
                  setTempFilters(filters);
                  setShowFilter(true);
                }}
              >
                <FiFilter className="text-xl" />
              </button>
            )}
            {["HR","DIRECTOR_MANAGEMENT"].includes(user?.role?.toUpperCase()) && (
              <button
                onClick={() => setIsOpen(true)}
                className="px-4 py-1.5 rounded bg-primary hover:bg-green-600 text-white font-bold shadow-md flex items-center gap-2"
              >
                <FiUpload className="text-md" />
                Upload
              </button>
            )}
          </div>
        </div>

        {/* Filter Modal */}
        {showFilter && (
          <CommonFilter
            title="Employee Documents Filter"
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
            onApply={handleApplyFilters}
            setSelectedUser={setSelectedUser}
            onClear={handleClearFilters}
            onCancel={handleCancelFilters}
            useSearchableUser={["HR","DIRECTOR_MANAGEMENT"].includes(user?.role?.toUpperCase())}
          />
        )}
        <InfiniteScroll
          dataLength={ess.length}
          next={loadMoreESS}
          hasMore={pagination.offset < pagination.count}
          scrollableTarget="scrollDiv"
        >
          <div
            className="h-[70vh] overflow-x-auto overflow-y-auto px-4 py-2 hidden md:block"
            id="scrollDiv"
          >
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <Loader />
              </div>
            ) : (
              <CommonTable
                tableColumns={EMP_DOC_COLUMNS}
                columnLabels={EMP_DOC_LABELS}
                tableRows={ess}
                renderField={renderField}
                headerClassName="bg-gray-100"
                rowClick={null}
              />
            )}
          </div>
        </InfiniteScroll>
        {/* Mobile Card View */}
        {renderMobileCards()}
        {renderForm()}
      </div>
    );
};

export default EmpDocs;


